import React, { useState } from 'react';
import { isEditorActive, RichText } from '@sitecore-jss/sitecore-jss-react';
import { setIsModalOpen, setNextPage, setPrevPage } from '../../../redux/slices/appStateSlice';
import { useDispatch, useSelector } from 'react-redux';
import { useInternalNavigate } from '../../../utils/navigate/useNavigate';

const Modal = ({ fields }) => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const dispatch = useDispatch();
  const navigate = useInternalNavigate();
  const preventPageUpdate = useSelector(state => state.appState.preventPageUpdate);

  const lockScroll = lock => {
    if (lock) {
      document.body.classList.add('vds-body-locked');
    } else {
      document.body.classList.remove('vds-body-locked');
    }
  };

  const toggleModal = () => {
    const opening = !isModalVisible;

    lockScroll(opening);
    setIsModalVisible(opening);
    dispatch(setIsModalOpen(opening));
  };

  const handleClick = e => {
    e.preventDefault();
    e.stopPropagation();
    if (!preventPageUpdate) {
      if (fields.nextPage?.value) {
        dispatch(setNextPage(fields.nextPage.value.href));
      }
      if (fields.prevPage?.value) {
        dispatch(setPrevPage(fields.prevPage.value.href));
      }
    }

    navigate(fields.secondaryCTA?.value?.href);
  };

  return (
    <>
      <div className="vds-form__group vds-form__group--limited-width">
        <button
          data-testid={`${fields.testid?.value}-cta`}
          className="vds-styled-link"
          type="button"
          onClick={toggleModal}
        >
          {fields.linkText?.value}
        </button>

        {isModalVisible && (
          <div
            data-testid={`${fields.testid?.value}-modal`}
            className="vds-modal vds-modal--open"
            style={{ display: 'block' }}
          >
            <div className="vds-modal__container">
              <div className="vds-modal__body">
                <button
                  className="vds-modal__close"
                  data-testid={`${fields.testid?.value}-close`}
                  type="button"
                  aria-label="Close"
                  onClick={toggleModal}
                ></button>

                <div className="vds-modal__content-container">
                  <div className="vds-modal__content">
                    <h3 className="vds-modal__title" data-testid={`${fields.testid?.value}-title`}>
                      {fields.modalTitle?.value}
                    </h3>

                    <h4 data-testid={`${fields.testid?.value}-heading`}>
                      {fields.modalHeading?.value}
                    </h4>

                    <RichText
                      field={fields.modalContent}
                      data-testid={`${fields.testid?.value}-content`}
                    />
                  </div>

                  {(isEditorActive() ||
                    fields.primaryCTA?.value?.text ||
                    fields.secondaryCTA?.value?.text) && (
                    <footer className="vds-modal__footer">
                      <div className="vds-cta-block vds-cta-block--center-aligned">
                        {fields.secondaryCTA?.value?.text && (
                          <button
                            className="vds-button vds-cta-block__button vds-button--line"
                            data-testid={`${fields.testid?.value}-secondary-cta`}
                            onClick={handleClick}
                          >
                            {fields.secondaryCTA?.value?.text}
                          </button>
                        )}
                        <button
                          className="vds-button vds-cta-block__button"
                          data-testid={`${fields.testid?.value}-close-cta`}
                          onClick={toggleModal}
                        >
                          {fields.primaryCTA?.value?.text}
                        </button>
                      </div>
                    </footer>
                  )}
                </div>
              </div>
            </div>
            <div className="vds-modal__background"></div>
          </div>
        )}
      </div>
    </>
  );
};

export default Modal;
